module.exports = __webpack_public_path__ + "static/icon_xhh-2b00f312baf1dcd6f57b4f66d0dfe4fc.png";